import React from 'react';
var NoopProvider = function (_a) {
    var children = _a.children;
    return React.createElement(React.Fragment, null, children);
};
export default NoopProvider;
//# sourceMappingURL=NoopProvider.js.map